export const messages = {
  en: {
    adminShop: {
      all: 'All'
    }
  },
  zh: {
    adminShop: {
      all: '全部'
    }
  }
}